import React from 'react';

import { NumberedPagination } from '../common/pagination/NumberedPagination';
import { CategoriesListItemLoading } from './CategoriesListItemLoading';
import { CategoriesListHeader } from './CategoriesListHeader';
import { CategoriesListItem } from './CategoriesListItem';
import { ListContainer } from '../common/ui/ListContainer';
import { Component } from '../common/ui/Component';
import { EmptyCard } from '../common/ui/EmptyCard';

export const CategoriesList = ({ isLoading, hasData, data, handlers, onReset }) => {
    if (isLoading) {
        return (
            <ListContainer>
                <CategoriesListHeader />
                <Component element={CategoriesListItemLoading} size={5} />
            </ListContainer>
        );
    }

    if (!hasData) {
        return (
            <ListContainer>
                <EmptyCard icon="shapes" text="No results found">
                    <button type="button" className="btn btn-outline-primary" onClick={onReset}>
                        Clear filter
                    </button>
                </EmptyCard>
            </ListContainer>
        );
    }

    return (
        <ListContainer>
            <CategoriesListHeader />
            {data.records.map((category) => (
                <CategoriesListItem
                    key={category.id}
                    onRefresh={handlers.onRefresh}
                    {...category}
                />
            ))}
            <NumberedPagination {...handlers} className="my-3" data={data} />
        </ListContainer>
    );
};
